
import React, { Fragment } from "react";
import { Row, Select, Checkbox, Table, Button, Col, DatePicker, message, Breadcrumb, Divider, Radio, Upload, Input, Modal } from "antd";
import { connect } from 'react-redux';
import moment from 'moment'
import Base64 from "base-64"
const previewRoot = global.url ? global.url.filePreview : null;
class FileDownload extends React.Component {
    state = {
    }

    componentDidMount() {
    }
    render() {
        return (
            <Fragment>
                {/* <Modal className="Filedownload_Modal" visible={preLookModalFlag} footer={null} title={"预览"} destroyOnClose={true}
                    onCancel={() => this.setState({ preLookModalFlag: false })} width={"80vw"}>
                    {nowClickFile ?
                        <Fragment>
                            <div className='Filedownload_Modal_Title'>
                                <div className='Filedownload_Modal_TitleText'>{nowClickFile.fileName}</div>
                            </div>
                            <div className='Filedownload_Modal_Content'>
                                <iframe id="Filedownload_Modal_Iframe" className='Filedownload_Modal_Iframe' src={this.returnUrl(nowClickFile.url)} onLoad={this.iframeOnload} />
                            </div>
                        </Fragment>
                        : <div className="Filedownload_Modal_Empty">暂无内容</div>}
                </Modal> */}
                {/* <iframe id="Filedownload_Modal_Iframe" className='ProductInspection' src={"https://www.baidu.com/"}/> */}
            </Fragment>
        )
    }

    //原先希望给后台页面发送更改style以适应界面大小的消息，但是有了分类显示逻辑后，暂无用处
    iframeOnload = () => {
        let iframeDocument = document.getElementById("Filedownload_Modal_Iframe");
        let style = {
            width: "100%",
            height: "100%"
        }
        iframeDocument.contentWindow.postMessage(style, "*");
    }
    //打开预览
    openPreLook = (text, file) => {
        console.log("openPreLook", text, file);
        this.setState({ preLookModalFlag: true, nowClickFile: file });
    }
    //返回预览链接
    returnUrl = (resourceUrl) => {
        if (!resourceUrl)
            return;
        let typeList = resourceUrl.split(".");
        let type = typeList[typeList.length - 1];
        console.log();
        if (type === "pdf" || type === "mp4" || type === "avi" || type === "mpeg" || type === "wmv" || type === "mov") {
            return resourceUrl + "#toolbar=0";
        }
        else {
            return `${previewRoot}/onlinePreview?url=${Base64.encode(resourceUrl)}`;
        }
    }
}

const mapState = (state) => ({ //返回值  对应的是  组件的props  
    user: state.userReducer.get('user').toJS()
})
const mapDispatch = (dispatch, ownProps) => ({
})

export default connect(mapState, mapDispatch)(FileDownload);
